// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__v_h9I","withBalance":"styles_withBalance___gr1V","secondary":"styles_secondary__3mPry"};